import { render, staticRenderFns } from "./TabelaTipoTexto.vue?vue&type=template&id=1b852598&scoped=true&"
import script from "./TabelaTipoTexto.vue?vue&type=script&lang=js&"
export * from "./TabelaTipoTexto.vue?vue&type=script&lang=js&"
import style0 from "./TabelaTipoTexto.vue?vue&type=style&index=0&id=1b852598&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b852598",
  null
  
)

export default component.exports